import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { useIntl } from '../useIntl';
/**
 * React component to format a currency
 */
export var FormattedCurrency = forwardRef(function FormatCurrency(props, ref) {
    var value = props.value, currency = props.currency, decimals = props.decimals, excludeCurrency = props.excludeCurrency, useCurrencySymbol = props.useCurrencySymbol, maxDecimals = props.maxDecimals, others = __rest(props, ["value", "currency", "decimals", "excludeCurrency", "useCurrencySymbol", "maxDecimals"]);
    var formatCurrencyToParts = useIntl().formatCurrencyToParts;
    var _a = formatCurrencyToParts(props), currencyInFront = _a.currencyInFront, currencySymbol = _a.currencySymbol, formattedNoCurrency = _a.formattedNoCurrency;
    var isCurrencyCode = currencySymbol.length === 3;
    var currencyClassName = isCurrencyCode ? 'cnqr-currency-code' : 'cnqr-currency-symbol';
    var nbsp = '\u00A0';
    return (React.createElement("span", __assign({}, others, { ref: ref }),
        !currencyInFront && formattedNoCurrency,
        !currencyInFront && isCurrencyCode && nbsp,
        React.createElement("span", { className: currencyClassName }, currencySymbol),
        currencyInFront && isCurrencyCode && nbsp,
        currencyInFront && formattedNoCurrency));
});
